import { Icon } from "@iconify/react";

import { useState, useEffect } from "react";
// material

import {
  Box,
  Stack,
  Button,
  MenuItem,
  TextField,
  Typography,
  Card,
  Autocomplete,
} from "@material-ui/core";
//

import apiUser from "../../../api/user";
import apiContact from "../../../api/contact";
import apiProvinces from "../../../api/provinces.open";
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------
import useAuth from "../../../hooks/useAuth";
import { objectID } from "../../../utils/objectID";
import ColorTagMultiPicker from "../../../components/ColorTagMultiPicker";
import ColorSinglePicker from "../../../components/ColorSinglePicker";
import { useSnackbar } from "notistack5";
import { Chip } from "@mui/material";
import { set } from "lodash";

// const LabelStyle = styled(Typography)(({ theme }) => ({
//     ...theme.typography.body2,
//     width: 140,
//     fontSize: 13,
//     flexShrink: 0,
//     color: theme.palette.text.secondary
// }));

// ----------------------------------------------------------------------

export default function TabContactGeneral({
  onChangeDepartment,
  infoContact,
  departmentSelected,
  formik,
  setCurrentTab,
  setIsRefreshContact,
  departments,
}) {
  const { errors, touched, setFieldValue, getFieldProps, values } = formik;
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedColorsInfo, setSelectedColorsInfo] = useState([]);
  const [errorAddTag, setErrorAddTag] = useState(false);
  const [messageErrorAddTag, setMessageErrorAddTag] = useState("");
  const { t } = useTranslation();
  const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [mappedTags, setMappedTags] = useState([]);

  const onChangeUserCreate = (e) => {
    setFieldValue("assigned_by", e.target.value);
  };
  const [addTags, setAddTags] = useState(false);
  const [colorOptions, setColorOptions] = useState([]);

  // const COLOR_OPTIONS = [
  //   { id: 1, color: "#FF4842", tag: "VIP" },
  //   { id: 2, color: "#3BEF37", tag: "Mới" },
  //   { id: 3, color: "#1890FF", tag: "Quan Tâm" },
  //   { id: 4, color: "#FFC107", tag: "Thường" },
  //   { id: 5, color: "#04297A", tag: "Đã Chốt" },
  // ];

  const findTags = async () => {
    try {
      const res = await apiUser.find_tags();
      if (res.status === 200) {
        let resDataTags = res?.data?.data;
        if (infoContact?.tags && infoContact?.tags.length > 0) {
          const tagsIdsInfo = infoContact?.tags.map((tag) => tag.id); // Extract IDs from tags1
          const filteredTags = resDataTags.filter(
            (tag) => !tagsIdsInfo.includes(tag.id)
          ); // Exclude matching IDs
          setColorOptions(filteredTags);
        } else {
          setColorOptions(resDataTags);
        }
      } else {
        // setColorOptions(COLOR_OPTIONS);
        enqueueSnackbar("Không tìm thấy danh sách nhãn, vui lòng thêm nhãn !", {
          variant: "error",
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Không tìm thấy danh sách nhãn, vui lòng thêm nhãn !", {
        variant: "error",
      });
      // setColorOptions(COLOR_OPTIONS);
    }
    // setColorOptions(res?.data);
  };
  useEffect(() => {
    findTags();
  }, [infoContact]);

  const COLOR_OPTIONS_MORE = [
    "#00AB55", // theme.palette.primary.main,
    "#1890FF", // theme.palette.info.main,
    "#94D82D", // theme.palette.success.main,
    "#FFC107", // theme.palette.warning.main,
    "#FF4842", // theme.palette.error.main
    "#04297A", // theme.palette.info.darker
    "#7A0C2E", // theme.palette.error.darker
  ];
  const [listUser, setListUser] = useState([]);
  const [province, setProvince] = useState({});
  const [district, setDistrict] = useState({});
  const [ward, setWard] = useState({});
  const [street, setStreet] = useState("");
  const [optionsProvince, setOptionsProvince] = useState([]);
  const [optionsDistrict, setOptionsDistrict] = useState([]);
  const [optionsWard, setOptionsWard] = useState([]);

  const isEmptyObject = (obj) => obj && Object.keys(obj).length === 0;
  const getListProvinces = async () => {
    const res = await apiProvinces.provinces();
    setOptionsProvince(res?.data);
  };
  useEffect(() => {
    const loadListUser = async () => {
      const res_list_user = await apiUser.view({
        department_id: departmentSelected?.value,
      });

      setListUser(res_list_user.data.data);
    };
    loadListUser();
    getListProvinces();
  }, [departmentSelected]);
  useEffect(() => {
    const fetchDistricts = async () => {
      if (!isEmptyObject(province)) {
        // if (province?.length > 0) {
        const response = await apiProvinces.districts(province);
        setOptionsDistrict(response?.data?.districts); // Reset district selection
        setOptionsWard([]); // Reset ward selection
      } else {
        setOptionsDistrict([]);
      }
    };
    fetchDistricts();
  }, [province]);

  useEffect(() => {
    const fetchWards = async () => {
      if (!isEmptyObject(district)) {
        const response = await apiProvinces.wards(district);
        setOptionsWard(response?.data?.wards); // Reset ward selection
      } else {
        setOptionsWard([]);
      }
    };
    fetchWards();
  }, [district]);

  useEffect(() => {
    setFieldValue(
      "address",
      (street ? `${street},` : "") +
        (ward ? `${ward?.name},` : "") +
        (district ? `${district?.name},` : "") +
        (province ? `${province?.name}` : "")
    );
    setFieldValue("addressStreet", street ? `${street},` : "");
    setFieldValue(
      "addressWDP",
      (ward ? `${ward?.name},` : "") +
        (district ? `${district?.name},` : "") +
        (province ? `${province?.name}` : "")
    );
    //eslint-disable-next-line
  }, [street, ward, district, province]);

  const handleChooseTag = (e) => {
    setSelectedColors(e);
    if (e.length > 0) {
      setFieldValue("tags", e);
    }
  };
  const handleAddTags = () => {
    setAddTags(!addTags);
    setFieldValue("tag", "");
    setFieldValue("color", "");
  };
  const handleAddTag = async () => {
    if (values.tag === "" || values.color === "") {
      setErrorAddTag(true);
      setMessageErrorAddTag("Bạn chưa chọn màu hoặc nhập tên nhãn !!!");
      return;
    }
    if (values.tag.length > 20) {
      setErrorAddTag(true);
      setMessageErrorAddTag("Tên nhãn không quá 20 ký tự !!!");
      return;
    }
    try {
      const insertTag = await apiUser.insert_tags({
        tag: values.tag,
        color: values.color,
      });
      if (insertTag.status === 200) {
        setAddTags(false);
        await findTags();
        enqueueSnackbar("Thêm nhãn thành công !", { variant: "success" });
      } else {
        enqueueSnackbar("Thêm nhãn thất bại, vui lòng thử lại !", {
          variant: "error",
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Thêm nhãn thất bại, vui lòng thử lại !", {
        variant: "error",
      });
    }
    setErrorAddTag(false);
    setMessageErrorAddTag("");
  };
  useEffect(() => {
    if (infoContact?.tags && infoContact?.tags?.length > 0) {
      setSelectedColorsInfo(infoContact?.tags); // Extract IDs from tags1
    }
  }, []);
  const handleDeleteTag = async (param, tag) => {
    try {
      await apiContact.delete_tag({
        id: objectID(param._id),
        tag,
      });
      enqueueSnackbar("Xóa thành công", { variant: "success" });
      setSelectedColorsInfo((pre) =>
        pre.filter((tagItem) => tag.id !== tagItem.id)
      );
      setIsRefreshContact(true);
    } catch (error) {
      enqueueSnackbar("Vui lòng kiểm tra lại nhãn", { variant: "error" });
    }
    //   findTags();
  };

  useEffect(() => {
    const fetchAndMapTags = async () => {
      if (selectedColorsInfo && selectedColorsInfo.length > 0) {
        try {
          const res = await apiUser.find_and_map_tags_by_arr_id({
            tags_id: selectedColorsInfo,
          });
          if (res.status === 200) {
            setMappedTags(res?.data?.data || []);
          } else {
            setMappedTags([]);
          }
        } catch (error) {
          console.error("Error fetching tags:", error);
          setMappedTags([]);
        }
      }
    };

    fetchAndMapTags();
  }, [selectedColorsInfo]);
  const InfoContactTag = () => {
    if (mappedTags && mappedTags.length > 0) {
      const renderTags = mappedTags.map((item) => {
        return (
          <Chip
            label={item.tag}
            onDelete={() => {
              handleDeleteTag(infoContact, item);
            }}
            sx={{
              color: "white",
              backgroundColor: item.color,
              cursor: "pointer",
              mt: 1,
              mr: 0.5,
            }}
          />
        );
      });
      return (
        <Box
          align="center"
          sx={{
            textOverflow: "ellipsis", // Add ellipsis for long text
          }}
          spacing={2}
        >
          {renderTags}
        </Box>
      );
    } else {
      return null;
    }
  };
  return (
    <Stack spacing={3} sx={{ px: 1.5, py: 2 }}>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: "700",
          lineHeight: "20px",
          color: "#303187",
        }}
      >
        THÔNG TIN CHUNG
      </Typography>
      <Card sx={{ p: 2 }}>
        <Stack spacing={3}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 3, sm: 2 }}
          >
            <TextField
              fullWidth
              label="Họ và tên*"
              {...getFieldProps("name")}
              InputLabelProps={{ shrink: true }}
              error={Boolean(touched.name && errors.name)}
              helperText={touched.name && errors.name}
            />
          </Stack>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 3, sm: 2 }}
          >
            <TextField
              fullWidth
              label="Địa chỉ Email"
              {...getFieldProps("email")}
              InputLabelProps={{ shrink: true }}
              error={Boolean(touched.email && errors.email)}
              helperText={touched.email && errors.email}
            />
            <TextField
              fullWidth
              label="Số điện thoại*"
              {...getFieldProps("phone")}
              InputLabelProps={{ shrink: true }}
              // error={Boolean(touched.phone && errors.phone)}
              // helperText={touched.phone && errors.phone}
            />
          </Stack>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 3, sm: 2 }}
          >
            <TextField
              select
              fullWidth
              label={"Phòng ban phụ trách"}
              placeholder={"Phòng ban"}
              name="department_id"
              {...getFieldProps("department_id")}
              error={Boolean(touched.department_id && errors.department_id)}
              helperText={touched.department_id && errors.department_id}
              onChange={(e) => onChangeDepartment(e)}
            >
              <MenuItem value="">{t("chosse_department")}</MenuItem>
              {departments.map((department, index) => {
                return (
                  <MenuItem value={objectID(department._id)}>
                    {t(department.name)}
                  </MenuItem>
                );
              })}
            </TextField>
            <TextField
              select
              fullWidth
              label="Chỉ định cho"
              placeholder="Chỉ định cho..."
              name="assigned_by"
              {...getFieldProps("assigned_by")}
              error={Boolean(touched.assigned_by && errors.assigned_by)}
              helperText={touched.assigned_by && errors.assigned_by}
              onChange={(e) => onChangeUserCreate(e)}
              defaultValue={user.id}
            >
              <MenuItem value={user.id}>Tôi</MenuItem>
              {listUser &&
                listUser.map((item, index) => {
                  if (objectID(item._id) !== user.id) {
                    return (
                      <MenuItem key={index} value={objectID(item._id)}>
                        {t(item.full_name)}
                      </MenuItem>
                    );
                  }
                })}
            </TextField>
          </Stack>
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              padding: 2,
              marginTop: 2,
            }}
          >
            <Typography variant="body2" sx={{ fontSize: "13px" }}>
              <strong>Địa chỉ:</strong>
            </Typography>
            <Stack
              sx={{ mt: 2 }}
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 3, sm: 2 }}
            >
              <TextField
                fullWidth
                label="Số nhà, Tên đường"
                onChange={(e) => setStreet(e.target.value)}
                error={Boolean(touched.company && errors.company)}
                helperText={touched.company && errors.company}
              />
            </Stack>
            <Stack
              sx={{ mt: 2 }}
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 3, sm: 2 }}
            >
              <Autocomplete
                fullWidth
                options={optionsProvince}
                getOptionLabel={(option) => option?.name || ""}
                value={province}
                onChange={(event, newValue) => {
                  setProvince(newValue);
                  if (!newValue) {
                    setOptionsDistrict([]);
                    setDistrict({});
                    setOptionsWard([]);
                    setWard({});
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Tỉnh/TP" />
                )}
              />
              <Autocomplete
                fullWidth
                options={optionsDistrict}
                getOptionLabel={(option) => option?.name || ""}
                value={district}
                onChange={(event, newValue) => {
                  setDistrict(newValue);
                  if (!newValue) {
                    setOptionsWard([]);
                    setWard({});
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Quận/Huyện" />
                )}
              />
              <Autocomplete
                fullWidth
                options={optionsWard}
                getOptionLabel={(option) => option?.name || ""}
                value={ward}
                onChange={(event, newValue) => setWard(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Phường/Xã" />
                )}
              />
            </Stack>
          </Box>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 3, sm: 2 }}
          >
            <TextField
              fullWidth
              label="Công ty"
              {...getFieldProps("company")}
              error={Boolean(touched.company && errors.company)}
              helperText={touched.company && errors.company}
            />
          </Stack>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 3, sm: 2 }}
          >
            <TextField
              fullWidth
              label="Ghi chú"
              multiline
              rows={3}
              {...getFieldProps("notes")}
              error={Boolean(touched.notes && errors.notes)}
              helperText={touched.notes && errors.notes}
            />
          </Stack>

          <Stack direction="column" spacing={1}>
            <Stack direction={"row"} spacing={1}>
              <Typography variant="body2" sx={{ fontSize: "13px" }}>
                <strong>Nhãn:</strong>
              </Typography>
            </Stack>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 3, sm: 2 }}
            >
              <InfoContactTag />
            </Stack>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 3, sm: 2 }}
            >
              {/* {!addTags ? <ColorTagSinglePicker onChange={(e) => handleChooseTag(e)} colors={COLOR_OPTIONS} /> : null} */}
              {!addTags ? (
                <ColorTagMultiPicker
                  onChange={(e) => handleChooseTag(e)}
                  selectedColors={selectedColors}
                  colors={colorOptions}
                />
              ) : null}
              <Box>
                <Button
                  color="secondary"
                  onClick={() => handleAddTags()}
                  startIcon={
                    addTags ? (
                      <Icon icon="icon-park-outline:down-two" />
                    ) : (
                      <Icon icon="typcn:plus-outline" />
                    )
                  }
                  sx={{ whiteSpace: "nowrap" }}
                  variant="outlined"
                >
                  {addTags ? "Hủy Thêm Nhãn" : "Thêm Nhãn"}
                </Button>
              </Box>
            </Stack>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 3, sm: 2 }}
            >
              {addTags ? (
                <>
                  <ColorSinglePicker
                    colors={COLOR_OPTIONS_MORE}
                    {...getFieldProps("color")}
                  />
                  <TextField
                    error={errorAddTag}
                    helperText={messageErrorAddTag}
                    variant="standard"
                    label="Tên Nhãn"
                    {...getFieldProps("tag")}
                  />{" "}
                  <Button
                    onClick={(e) => handleAddTag(e)}
                    color="secondary"
                    variant="contained"
                    sx={{ ml: 1, height: "46px" }}
                  >
                    Thêm nhãn
                  </Button>
                </>
              ) : null}
            </Stack>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  );
}
